import CallAPI from "@/functions/Cl_api";
import { Cl_common } from "@/functions/Cl_common";
import { DtoRequestAddchgsGetReqImple } from "furukawa-common/src/common/dto/DtoRequestAddchgsGetReqImple";
import { DtoRequestAddchgsGetResImple } from "furukawa-common/src/common/dto/DtoRequestAddchgsGetResImple";
import { DtoRequestAddchgsPostReq } from "furukawa-common/src/common/dto/abst/DtoRequestAddchgsPostReq";
import { DtoRequestAddchgsPostRes } from "furukawa-common/src/common/dto/abst/DtoRequestAddchgsPostRes";
import { DtoRequestAddchgsPutReq } from "furukawa-common/src/common/dto/abst/DtoRequestAddchgsPutReq";
import { DtoRequestAddchgsPutRes } from "furukawa-common/src/common/dto/abst/DtoRequestAddchgsPutRes";
import { DtoRequestAddchgsDeleteReq } from "furukawa-common/src/common/dto/abst/DtoRequestAddchgsDeleteReq";
import { DtoRequestAddchgsDeleteRes } from "furukawa-common/src/common/dto/abst/DtoRequestAddchgsDeleteRes";

export class Cl_requestaddchg {
  public static async getList(
    dto: DtoRequestAddchgsGetReqImple
  ): Promise<DtoRequestAddchgsGetResImple> {
    return Object.assign(
      new DtoRequestAddchgsGetResImple(),
      await CallAPI.getRequest(
        "/requestAddchgs?" +
          Cl_common.cnvObj2GetParam(dto.pager) +
          "&" +
          Cl_common.cnvObj2GetParam(dto)
      )
    );
  }

  public static async get(
    dto: DtoRequestAddchgsGetReqImple
  ): Promise<DtoRequestAddchgsGetResImple> {
    return Object.assign(
      new DtoRequestAddchgsGetResImple(),
      await CallAPI.getRequest("/requestAddchgs/" + dto.c_request_addchg_id)
    );
  }

  public static async post(
    dto: DtoRequestAddchgsPostReq
  ): Promise<DtoRequestAddchgsPostRes> {
    return Object.assign(
      new DtoRequestAddchgsPostRes(),
      await CallAPI.postRequest("/requestAddchgs", dto)
    );
  }

  public static async put(
    dto: DtoRequestAddchgsPutReq
  ): Promise<DtoRequestAddchgsPutRes> {
    return Object.assign(
      new DtoRequestAddchgsPutRes(),
      await CallAPI.putRequest(
        "/requestAddchgs/" + dto.c_request_addchg_id,
        dto
      )
    );
  }

  public static async del(
    dto: DtoRequestAddchgsDeleteReq
  ): Promise<DtoRequestAddchgsDeleteRes> {
    return Object.assign(
      new DtoRequestAddchgsDeleteRes(),
      await CallAPI.deleteRequest(
        "/requestAddchgs?" + Cl_common.cnvObj2GetParam(dto)
      )
    );
  }
}
